
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "gallbladder_carcinoma",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/gallbladder_carcinoma_test.vue